/*
 * Father's Day Bundle — ATC hijack.
 * Loaded only on /products/fathers-day-bundle. When the customer clicks Add
 * to Cart, instead of adding the wrapper SKU we add the real components:
 *   • 4 × Down Alternative Pillow (Soft Fluff, matching size)
 *   • 2 × Hotel Pillowcase Set (matching size)
 *
 * Each line gets _target_total_cents stamped so the cart prices them down
 * to the bundle total ($183 Standard / $210 King). _bundle_source =
 * 'fathers-day-bundle' lets the cart suppress the $150 Pillowcase Set GWP
 * (since the bundle already includes 2 sets — don't want a 3rd added free).
 *
 * Uses a capture-phase submit listener + stopImmediatePropagation so the
 * regular pillow-PDP ATC handler (registered inline by the snippet) never
 * fires for this product.
 */
(function () {
  var ROOT_SELECTOR = '[data-fc-pdp][data-handle="fathers-day-bundle"]';
  var FORM_SELECTOR = '[data-fc-atc-form]';

  // Pillow variant lookup keyed by (size, fluff). Pillowcase variants only
  // vary by size. Per-line bundle math (_target_total_cents) sums to $183 /
  // $210 so the cart subtotal lands exactly on the bundle price.
  var PILLOW = {
    'Standard|Soft Fluff™': 36266686840993,
    'Standard|Firm Fluff™': 36266686873761,
    'King|Soft Fluff™':     39741546496161,
    'King|Firm Fluff™':     39741543219361
  };
  var T = {
    Standard: {
      cV: 43591587856618,    // Hotel Pillowcase Set — Standard
      pT: 15123, cT: 3177,   // _target_total_cents per line → sums to 18300 ($183)
      pU: 6900,  cU: 2900,
      pC: 27600, cC: 5800    // compare totals (4×$69 + 2×$29 = $334)
    },
    King: {
      cV: 43591587922154,    // Hotel Pillowcase Set — King
      pT: 16842, cT: 4158,   // sums to 21000 ($210)
      pU: 7900,  cU: 3900,
      pC: 31600, cC: 7800    // compare totals (4×$79 + 2×$39 = $394)
    }
  };

  function readSize(root) {
    var sel = root.querySelector('[data-fc-size-btn].is-active, [data-fc-size].is-active');
    if (sel) {
      var v = (sel.dataset.fcSizeBtn || sel.dataset.fcSize || sel.textContent || '').trim();
      if (v.toLowerCase().indexOf('king') > -1) return 'King';
    }
    return 'Standard';
  }

  function readFluff(root) {
    var sel = root.querySelector('[data-fc-firmness].is-active, [data-fc-firmness-btn].is-active');
    if (sel) {
      var v = (sel.dataset.fcFirmness || sel.dataset.fcFirmnessBtn || sel.textContent || '').trim();
      if (v.toLowerCase().indexOf('firm') > -1) return 'Firm Fluff™';
    }
    return 'Soft Fluff™';
  }

  function build(size, fluff) {
    var c = T[size] || T.Standard;
    var pillowVid = PILLOW[size + '|' + fluff] || PILLOW['Standard|Soft Fluff™'];
    var label = "Father's Day Bundle — " + size + ' / ' + fluff;
    function props(role, target, qty, unit, compare) {
      return {
        _target_total_cents: target,
        _bundle_qty: qty,
        _unit_price_cents: unit,
        _compare_total_cents: compare,
        _bundle_source: 'fathers-day-bundle',
        _bundle_size: size,
        _bundle_fluff: fluff,
        _bundle_role: role,
        'Bundle Discount': label
      };
    }
    return [
      { id: pillowVid, quantity: 4, properties: props('pillow',    c.pT, 4, c.pU, c.pC) },
      { id: c.cV,       quantity: 2, properties: props('pillowcase', c.cT, 2, c.cU, c.cC) }
    ];
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var form = root.querySelector(FORM_SELECTOR);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      // Capture phase + stopImmediatePropagation blocks the inline pillow-PDP
      // ATC handler from also firing on this submit.
      e.preventDefault();
      e.stopImmediatePropagation();

      var atcBtn = form.querySelector('[data-fc-atc]');
      var atcTextEl = form.querySelector('[data-fc-atc-text]');
      var origText = atcTextEl ? atcTextEl.textContent : '';

      var size  = readSize(root);
      var fluff = readFluff(root);
      var items = build(size, fluff);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      }).then(function () {
        if (atcBtn) atcBtn.classList.add('is-added');
        if (atcTextEl) atcTextEl.textContent = '✓ Added to Cart!';
        // Open the cart drawer if the theme provides one; otherwise notify.
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(atcBtn);
        else document.dispatchEvent(new CustomEvent('cart:item-added'));
        setTimeout(function () {
          if (atcBtn) atcBtn.classList.remove('is-added');
          if (atcTextEl) atcTextEl.textContent = origText;
        }, 2000);
      }).catch(function (err) {
        console.error('[FDB ATC] failed:', err);
        if (atcTextEl) atcTextEl.textContent = 'Try again';
      });
    }, true); // capture phase
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
